/* eslint-disable no-undef */
import { useEffect } from 'react';
import PropTypes from 'prop-types';

const CalendlyModal = ({ buttonId, url, prefillMessage, prefillField = 'a1' }) => {
  useEffect(() => {
    // Load Calendly script
    const existingScript = document.querySelector(
      'script[src="https://assets.calendly.com/assets/external/widget.js"]'
    );

    if (!existingScript) {
      const script = document.createElement('script');
      script.src = 'https://assets.calendly.com/assets/external/widget.js';
      script.async = true;
      document.body.appendChild(script);
    }

    // Set up click listener for the button
    const button = document.getElementById(buttonId);

    const handleClick = (e) => {
      e.preventDefault();

      if (window.Calendly) {
        // Build URL with prefill message if provided
        let calendlyUrl = url;
        if (prefillMessage) {
          const separator = url.includes('?') ? '&' : '?';
          const encodedMessage = encodeURIComponent(prefillMessage);
          calendlyUrl = `${url}${separator}${prefillField}=${encodedMessage}`;
        }

        window.Calendly.initPopupWidget({ url: calendlyUrl });
      }
    };

    if (button) {
      button.addEventListener('click', handleClick);
    }

    // Cleanup
    return () => {
      if (button) {
        button.removeEventListener('click', handleClick);
      }
    };
  }, [buttonId, url, prefillMessage, prefillField]);

  // This component doesn't render anything visible
  return null;
};

CalendlyModal.propTypes = {
  buttonId: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  prefillMessage: PropTypes.string,
  prefillField: PropTypes.string,
};

CalendlyModal.defaultProps = {
  prefillMessage: null,
  prefillField: 'a1',
};

export default CalendlyModal;

